import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { device } from './config/device'
import plugin from './plugin'

Vue.config.productionTip = false
Vue.use(plugin)

const init = () => {
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}

if (device.standalone) {
  document.addEventListener('deviceready', init, false)
} else {
  init()
}
